const state = {
  administrative_corrections:
    JSON.parse(localStorage.getItem("administrative_corrections") as any) || [],
}

export default {
  ...state,
}
